import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Preload hero image (LCP element)
if (!document.querySelector('link[data-hero-preload]')) {
  const preloadLink = document.createElement('link');
  preloadLink.rel = 'preload';
  preloadLink.as = 'image';
  preloadLink.setAttribute('data-hero-preload', 'true');
  preloadLink.href = 'https://cdn.magicpatterns.com/uploads/bsHsKwT54KqnULakoAuxPz/mocap_metodo_calma.png';
  document.head.appendChild(preloadLink);
}
render(<App data-id="element-249" />, document.getElementById('root'));